import React from 'react';
import Typography from 'Components/DesignSystem/Typography/Typography';

interface LoadingOverlayProps {
  message?: string;
}

// !tw-mt-0: the views mount this inside a `tw-space-y-4` container, whose
// `> * ~ *` rule adds margin-top:1rem to EVERY following sibling — including
// this absolutely-positioned overlay. `top:0` doesn't cancel a margin, so the
// overlay's top edge landed 16px below the view root and sliced through the
// ActionBar buttons: the uncovered top band stayed full-color while the
// covered rest was washed out by the white/75 — the "two-tone button" of
// ticket 14051. The important reset wins over space-y's higher-specificity
// `:not() ~ :not()` selector.
const LoadingOverlay = ({ message = 'Processing...' }: LoadingOverlayProps) => (
  <div className="tw-absolute tw-inset-0 !tw-mt-0 tw-bg-[color-mix(in_srgb,var(--ds-surface)_75%,transparent)] tw-flex tw-flex-col tw-items-center tw-justify-center tw-z-50 tw-gap-[3px]">
    <div className="tw-animate-spin tw-rounded-full tw-h-10 tw-w-10 tw-border-2 tw-border-edge tw-border-t-accent" />
    <Typography variant="body-primary" className="tw-text-ink">
      {message}
    </Typography>
  </div>
);

export default LoadingOverlay;
